import { useRateTableDimension } from './useRateTableDimension';

export const useIsRateTableDimensionEnabled = ({
  projectId,
  dimensionType
}) => {
  const { projectDimensions, loading } = useRateTableDimension({
    projectId
  });

  return {
    isDimensionEnabled:
      !loading && projectDimensions.some(d => d.objectType === dimensionType),
    loading
  };
};
